export const profile = {
  type: "none"
};


